// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import api from '../../services/api';

export default function AdminLayout() {
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await api.get('/dashboard/stats');
        setCompanyName(response.data.company?.name || '');
      } catch (error) {
        console.error('Failed to fetch company info:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyInfo();
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F6F8' }}>
      <AdminSidebar />
      <AdminHeader companyName={companyName} />
      
      {/* Main Content */}
      <main 
        className="pt-16"
        style={{ marginLeft: '240px', minHeight: '100vh' }}
      >
        <div className="p-8">
          <Outlet context={{ companyName, loading }} />
        </div>
      </main>
    </div>
  );
}
